/*
 * Aides partagees de la page bilan : lien de reservation et generation PDF.
 * Seul l'identifiant commercial aleatoire est transmis dans les adresses.
 */

import { generateBilanPdf } from "@/lib/pdfBilan";
import { getJourneyId } from "@/lib/quizStorage";

export function buildBookingLink(bookingUrl, journeyId) {
  // Jamais de prenom, d'email, de reponses ni de scores dans une URL.
  try {
    const parsed = new URL(bookingUrl);
    parsed.searchParams.set("diagnostic", journeyId);
    return parsed.toString();
  } catch (e) {
    return bookingUrl + (bookingUrl.includes("?") ? "&" : "?") + "diagnostic=" + encodeURIComponent(journeyId);
  }
}

export async function makePdfBytes(result, settings, prenom) {
  const bookingLink = buildBookingLink(settings?.booking_url || "", getJourneyId());
  return generateBilanPdf(result, bookingLink, {
    prenom: (prenom || "").trim(),
    baremeVersion: result.bareme_version || settings?.bareme_version || "",
    journeyRef: getJourneyId(),
  });
}
